import { COLORS } from 'helpers/globals'

const button = {
  padding: '.4rem 1rem',
  borderRadius: '1rem',
  color: 'white',
  fontSize: '1.4rem',
  fontWeight: 400,
  cursor: 'pointer'
}

export default {
  networkClosetDetails: {
    flex: '0 0 65%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    background: 'white',
    '&:after': {
      position: 'absolute',
      width: '100%',
      height: '1.5rem',
      bottom: '0',
      content: '""',
      background: 'linear-gradient(to top, rgba(200,200,200, 1), rgba(255,255,255, 0))'
    }
  },
  header: {
    padding: '1rem 2rem',
    minHeight: '5rem',
    fontSize: '1.8rem',
    fontWeight: '400',
    background: COLORS.primary,
    color: 'white'
  },
  body: {
    paddingBottom: '3rem',
    color: 'black',
    minHeight: 0,
    overflow: 'auto'
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    color: COLORS.primary,
    fontSize: '2.5rem',
    padding: '1rem 0'
  },
  deleteButton: {
    color: 'red'
  },
  colorButton: {
    background: COLORS.primary,
    width: '4rem',
    textAlign: 'center',
    borderRadius: '1rem'
  },
  colorIcon: {
    verticalAlign: '-.4rem'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem'
  },
  nameInput: {
    margin: '0 1rem',
    flex: 1
  },
  devicesContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1rem',
    overflowY: 'auto'
  },
  device: {
    padding: '0 1rem',
    display: 'flex',
    alignItems: 'center',
    '&:nth-of-type(odd)': { background: COLORS.tertiary }
  },
  distanceText: {
    fontSize: '1.2rem',
    display: 'block'
  },
  distanceTextFadeIn: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s linear 0s, opacity 200ms linear'
  },
  distanceTextFadeOut: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s linear 200ms, opacity 200ms linear'
  },
  disconnectIcon: {
    fontSize: '2.2rem',
    color: 'red'
  },
  instructions: {
    display: 'flex',
    fontSize: '1.4rem',
    marginLeft: '1.5rem',
    '& svg': {
      color: COLORS.warning,
      fontSize: '2.5rem',
      marginRight: '1rem'
    },
    '& ol': { margin: 0 },
    '& li': { margin: 0 }
  },
  cancelButton: {
    ...button,
    background: 'red',
    '&:hover': { background: '#E60000' }
  },
  drawWireButton: {
    ...button,
    background: COLORS.primary,
    '&:hover': { background: '#2972B1' }
  },
  disabledButton: {
    ...button,
    background: COLORS.primary,
    cursor: 'not-allowed',
    opacity: '0.8'
  },
  wiredDeviceIcon: {
    borderRadius: '50%',
    color: 'white',
    flex: '0 1 3rem',
    height: '3rem',
    display: 'flex',
    marginRight: '1rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/NetworkClosetDetails/style.js